import { app } from '../../app';

app.component('spHeader', {
    templateUrl: require('./sp-header.html'),
    transclude: true,
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-header/sp-header.component.js